import backend from 'utils/backend';

// Pairs a schedule reader with the route its tiles link to, so the Loom sandbox is one
// prop rather than a second set of components. CQ-419 deletes LOOM and keeps the reader.
const SCHEDULE_SOURCES = {
  LEGACY: {
    loadClientRange: (clientRn, start, end, options) =>
      backend.client.schedule.loadByIsoRange(clientRn, start, end, true, options),
    loadCaregiverRange: (caregiverRn, start, end, options) =>
      backend.caregiver.schedule.loadByIsoRange(caregiverRn, start, end, true, options),
    loadEvent: (eventRn) => backend.event.loadEvent(eventRn, true, true, true, true),
    loadClients: (filters, sort, cursor) => backend.client.queryClient(filters, sort, cursor),
    loadCaregivers: (filters, sort, cursor) => backend.caregiver.queryCaregiver(filters, sort, cursor),
    detailPath: '/schedule/event',
    clientPath: '/client',
    caregiverPath: '/caregiver',
  },
  LOOM: {
    loadClientRange: (clientRn, start, end, options) =>
      backend.loom.schedule.loadClientRange(clientRn, start, end, options),
    loadCaregiverRange: (caregiverRn, start, end, options) =>
      backend.loom.schedule.loadCaregiverRange(caregiverRn, start, end, options),
    loadEvent: (eventRn) => backend.loom.schedule.loadEvent(eventRn),
    loadClients: (filters, sort, cursor) => backend.loom.schedule.loadClients(filters, sort, cursor),
    // The calendar refetches every row whenever the roster grows, so a 25-row page turned 552
    // active caregivers into 23 restarts. Legacy sends no limit and the server pages far larger.
    loadCaregivers: (filters, sort, cursor) =>
      backend.loom.caregiver.queryCaregiver(filters, sort, cursor, {limit: 100}),
    detailPath: '/schedule/event/loom',
    // /client/loom/:clientRn arrives with CQ-406 and does not exist on this branch yet.
    clientPath: '/client/loom',
    caregiverPath: '/caregiver-loom',
  },
};

export default SCHEDULE_SOURCES;
